export default __webpack_public_path__ + "static/media/new_main_right_arrow.c341bd23.svg";